.button {
  text-transform: none;
  padding: 2px 10px;
  min-width: 0;
}
